// Cross Referencing between Jobs and Cleass
export const factions = [
  {
    key: 'explorer',
    name: 'Explorer',
    jobsAvailableIn: [0, -10, 1, 2, 3, 4, 5],
  },
  {
    key: 'cygnus-knights',
    name: 'Cygnus Knights',
    jobsAvailableIn: [10, 11, 12, 13, 14, 15, 202],
  },
  {
    key: 'resistance',
    name: 'Resistance',
    jobsAvailableIn: [30, 215, 32, 33, 208, 35, 209, 31],
  },
  {
    key: 'hero',
    name: 'Hero',
    jobsAvailableIn: [21, 22, 203, 20, 23, 24, 212],
  },
  {
    key: 'nova',
    name: 'Nova',
    jobsAvailableIn: [204, 222, 216, 205],
  },
  {
    key: 'flora',
    name: 'Flora',
    jobsAvailableIn: [221, 217, 218, 224],
  },
  {
    key: 'sengoki',
    name: 'Sengoku',
    jobsAvailableIn: [206, 207],
  },
  {
    key: 'anima',
    name: 'Anima',
    jobsAvailableIn: [223, 220],
  },
  {
    key: 'others',
    name: 'Others',
    jobsAvailableIn: [210, 214, 225, 226, 227],
  },
]

export const jobs = [
  { id: 0, name: 'Beginner' },
  { id: -10, name: 'Beginner (Origin)' }, // requires special query modification
  { id: 1, name: 'Warrior' },
  { id: 2, name: 'Magician' },
  { id: 3, name: 'Bowman' },
  { id: 4, name: 'Thief' },
  { id: 5, name: 'Pirate' },
  { id: 10, name: 'Noblesse' },
  { id: 11, name: 'Dawn Warrior' },
  { id: 12, name: 'Blaze Wizard' },
  { id: 13, name: 'Wind Archer' },
  { id: 14, name: 'Night Walker' },
  { id: 15, name: 'Thunder Breaker' },
  { id: 20, name: 'Legend' },
  { id: 21, name: 'Aran' },
  { id: 22, name: 'Evan' },
  { id: 23, name: 'Mercedes' },
  { id: 24, name: 'Phantom' },
  { id: 30, name: 'Citizen' },
  { id: 31, name: 'Demon Slayer' },
  { id: 32, name: 'Battle Mage' },
  { id: 33, name: 'Wild Hunter' },
  { id: 35, name: 'Mechanic' },
  // { id: 113, name: 'Hero' },
  // { id: 123, name: 'Paladin' },
  // { id: 133, name: 'Dark Knight' },
  { id: 201, name: 'Jett' },
  { id: 202, name: 'Mihile' },
  { id: 203, name: 'Luminous' },
  { id: 204, name: 'Kaiser' },
  { id: 205, name: 'Angelic Buster' },
  { id: 206, name: 'Hayato' },
  { id: 207, name: 'Kanna' },
  { id: 208, name: 'Xenon' },
  { id: 209, name: 'Demon Avenger' },
  { id: 210, name: 'Zero' },
  { id: 211, name: 'Beast Tamer' },
  { id: 212, name: 'Shade' },
  // { id: 213, name: 'Fire/Poison' },
  { id: 214, name: 'Kinesis' },
  { id: 215, name: 'Blaster' },
  { id: 216, name: 'Cadena' },
  { id: 217, name: 'Illium' },
  { id: 218, name: 'Ark' },
  { id: 219, name: 'Pathfinder' },
  { id: 223, name: 'Lara' },
  { id: 220, name: 'Hoyoung' },
  { id: 221, name: 'Adele' },
  { id: 222, name: 'Kain' },
  { id: 224, name: 'Khali' },
  { id: 225, name: 'Lynn' },
  { id: 226, name: 'Mo Xuan' },
  { id: 227, name: 'Sia Astelle' },
]
